enum PrecaucoesFromTasyTipoEnum {
  ALERGIA = 'alergia',
  PRECAUCAO = 'precaucao',
}

export default PrecaucoesFromTasyTipoEnum
